import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const H2 = ({ children, className }) =>
  <h2 className={classNames('H2', className)}>
    {children}
  </h2>;

H2.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

H2.defaultProps = {
  className: null,
};

export default H2;



// WEBPACK FOOTER //
// ./src/components/H2/index.js